<template>
    <div>
    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        name: "css_methods",
        computed:{
            store(){
                return this.$store.state
            }
        },
        methods:{
            browser_fixes: function () {
                var body = $('body, #front-app');

                if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                    body.addClass('fix-ff');
                }
                if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                    body.addClass('fix-ios')
                }
                if (/Android/.test(navigator.userAgent) && !window.MSStream) {
                    body.addClass('fix-android')
                }
                if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                    body.addClass('fix-ie11')
                }
                if (/Edge/.test(navigator.userAgent)) {
                    body.addClass('fix-edge')
                }
            },
            minimum_body_height: function(){
                setTimeout(function(){

                    var content_height = $('#front-app #footer-app').outerHeight()+$('#front-app .main-container').outerHeight()+$('#front-app #header-app').outerHeight();
                    $('body,#front-app').css({'min-height':content_height*1.05 + 'px' })
                    // $('.background_overlay').css({'height':window_height + 'px' })
                    var outer_height =
                      $('body').css({'height': $(window).outerHeight() + 'px'})

                    var device_height = $(window).innerHeight();
                    $('#front-app').css({'height': device_height + 'px'})

                },5)
            },
            center_label_text: function () {
                setTimeout(function () {

                    $('.checks_outer').each(function (index, value) {

                        var el = $(value)
                        var label = el.find('span')

                        // label.css({'line-height':'2.75rem'})

                        let checks_height = $('.checkbox-height-helper').height()

                        let label_line_height = label.css('line-height').split('px')[0]

                        let label_height = label.height()

                        if (label_height > label_line_height) {
                            label.css({'line-height': checks_height / 2 + 'px'})
                        } else {
                            label.css({'line-height': checks_height + 'px'})
                        }

                    })
                }, 200)
            }
        },
        watch:{
            'store.active_view': {
                handler(){
                    this.minimum_body_height();
                    this.center_label_text();
                }
            }
        },
        mounted(){
            this.browser_fixes()
            this.minimum_body_height()
            this.center_label_text();

            window.addEventListener('resize',()=> {
                this.minimum_body_height();
                this.center_label_text();
            })

        }
    }

</script>

<style scoped>

</style>